module.exports = {
  materialData: () => {
    return {
      "STARIA LUJO": {


        "BodyPaint":{
          "type": "physical",
          "name": "BodyPaint",
          "enable": true,
          "color": 0xEBE9E2,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": false,
          "opacity": 1,
          "side": 2,
          "reflectivity": 1,
          "thickness": 0,
          "transmission": 0,
          

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 1.8,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0.6,
          "roughness": 0.4,

          "realTimeEnvironment": true,
        },
        
        "Ext_Sun_Roof":{
          "type": "physical",
          "enable": true,
          "color": 0x636363,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.75,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 3.25,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Windows":{
          "type": "physical",
          "enable": true,
          "color": 0x224D62,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.7,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 5,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Glass_Clear":{
          "type": "physical",
          "enable": true,
          "color": 0x224D62,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.6,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 2,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Material_Atlas":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
              "texture": require('./../../assets/STARIA/maps/MaterialAtlas_ORM.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": false,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/MaterialAtlas_C.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "aoMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2.5,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Material_Atlas_Int":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
              "texture": require('./../../assets/STARIA/maps/MaterialAtlas_ORM.png'),
              "channel": 0,
              "flipY": true,
              "generateMipmaps": false,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 1,"y": 1},
          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/MaterialAtlas_C.png'),
            "channel": 0,
            "flipY": true,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "aoMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 20,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 0,
        },

        "Material_Atlas_BlackGlossy":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
              "texture": require('./../../assets/STARIA/maps/MaterialAtlas_ORM.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": false,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/MaterialAtlas_C.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "aoMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 10.5,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },


        "EmissiveWhiteSeamlesly":{
            "type": "standard",
            "enable": true,
            "color": 0xFFFFFF,
            "transparent": true,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
  
            "alphaMap": {
              "texture": require('./../../assets/STARIA/maps/Seamlesly.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 110,"y": 110},
            },
            "envMap": { "texture": "globalEnvMap" },
  
            "aoMapIntensity": 1,
            "emissive": 0xFFFFFF,
            "emissiveIntensity": .2,
            "envMapIntensity": 0.1,
            "lightMapIntensity": 0.15,
            "metalness": 0,
            "roughness": 0.65,

            "lightsOffTransition": {
              "updateAt": "transition", 
              "emissiveIntensity": 2.2,
              "envMapIntensity": 1.8,
              "opacity": 1,
              "emissive": 0xFFFFFF,
            },
            "lightsOnTransition": {
              "updateAt": "transition", 
              "emissiveIntensity": 0,
              "envMapIntensity": 1,
              "opacity": 1,
              "emissive": 0xFFFFFF,
            },
          },

          "EmissiveRedSeamlesly":{
            "type": "standard",
            "enable": true,
            "color": 0xFF0000,
            "transparent": true,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
  
            "alphaMap": {
              "texture": require('./../../assets/STARIA/maps/Seamlesly.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 110,"y": 110},
            },
            "envMap": { "texture": "globalEnvMap" },
  
            "aoMapIntensity": 1,
            "emissive": 0xFF0000,
            "emissiveIntensity": 0.15,
            "envMapIntensity": 1,
            "lightMapIntensity": 0.5,
            "metalness": 0,
            "roughness": 0.65,

            "lightsOffTransition": {
              "updateAt": "transition", 
              "emissiveIntensity": 5.5,
              "envMapIntensity": 1.8,
              "opacity": 1,
              "emissive": 0xB70600,
            },
            "lightsOnTransition": {
              "updateAt": "transition", 
              "emissiveIntensity": 0,
              "envMapIntensity": 1,
              "opacity": 1,
              "emissive": 0xB70600,
            },
          },


        "EmissiveRed":{
          "type": "standard",
          "enable": true,
          "color": 0xC9C9C9,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0xB70600,
          "emissiveIntensity": 0,
          "envMapIntensity": 0.5,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 100,
            "envMapIntensity": 3.5,
            "opacity": 1,
            "emissive": 0xB70600,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0.5,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xB70600,
          },
        },


        "EmissiveRedInt":{
          "type": "standard",
          "enable": true,
          "color": 0xB70600,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0xB70600,
          "emissiveIntensity": 0,
          "envMapIntensity": 0,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 1.5,
            "opacity": 1,
            "emissive": 0xB70600,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xB70600,
          },
        },

        "EmissiveYellow":{
          "type": "standard",
          "enable": true,
          "color": 0xC9C9C9,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0xE5AC08,
          "emissiveIntensity": 0,
          "envMapIntensity": 1.8,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 6.25,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
        },

        "EmissiveGray":{
          "type": "standard",
          "enable": true,
          "color": 0xC9C9C9,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.8,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "end", 
            "emissiveIntensity": 1,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0x737373,
          },
          "lightsOnTransition": {
            "updateAt": "start", 
            "emissiveIntensity": 0.1,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xC9C9C9,
          },
        },

        "EmissiveWhite":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Reflector_N.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1.0,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 7,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xFFFFFF,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1.0,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0x000000,
          },
        },

        "EmissiveWhite3":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 0.1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0.65,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xFFFFFF,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0.1,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0x000000,
          },
        },

        "EmissiveWhite4":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 2,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xFFFFFF,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0x000000,
          },
        },

        "GlassRed":{
          "type": "physical",
          "enable": true,
          "color": 0xB70600,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 1,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 2,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 1,

          "realTimeEnvironment": true,
        },


        "GlassReflector":{
          "type": "physical",
          "enable": true,
          "color": 0xBABABA,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": false,
          "transparent": true,
          "opacity": 1,
          "side": 0,
          "reflectivity": 0.3,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 6,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "GlassReflectorInt":{
          "type": "physical",
          "enable": true,
          "color": 0xFFFFFF,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": false,
          "transparent": true,
          "opacity": 0.8,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 3,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "DashPlastic":{
          "type": "standard",
          "enable": true,
          "color": 0x292929,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Image_10.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 850,"y": 850},
          },
          "normalScale": {"x": 0.35,"y": -0.3},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 7,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.45,
        },

        "Panel":{
          "type": "standard",
          "enable": true,
          "color": 0x292929,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/MeshFrontalV.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },

          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/MeshFrontalVNM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 0.35,"y": -0.3},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 7,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.45,
        },

        "ScreenPanelE":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/STARIA/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.75,
          "envMapIntensity": 0.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "MainBoard":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/STARIA/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.5,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "EmissiveAluminum":{
          "type": "standard",
          "enable": true,
          "color": 0xF0F0F0,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/Image_7_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/STARIA/maps/Image_8_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.2,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 0.27,
        },

        "LinealPattern":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/Image_37.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.5,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.3,
        },

        "Speakers":{
          "type": "standard",
          "enable": true,
          "color": 0x111111,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/Image_7_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2.8,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,
        },

        "Mesh":{
          "type": "standard",
          "enable": true,
          "color": 0x111111,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/Reja.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2.8,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,
        },

        "MeshBag":{
          "type": "standard",
          "enable": true,
          "color": 0x111111,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/1140.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2.8,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,
        },
        
          "Leather_Rougth":{
            "type": "standard",
            "enable": true,
            "color": 0x333333,
            "transparent": false,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
  
            "normalMap": {
              "texture": require('./../../assets/STARIA/maps/BPE6C3_n.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 1,"y": 1},
            },
            "normalScale": {"x": 1,"y": -1},
            "envMap": { "texture": "globalEnvMap" },
  
            "aoMapIntensity": 1,
            "emissive": 0x000000,
            "emissiveIntensity": 1,
            "envMapIntensity": 5,
            "lightMapIntensity": 0,
            "metalness": 0.75,
            "roughness": 0.4,
          },

          "Leather_Rough_Dots":{
            "type": "standard",
            "enable": true,
            "color": 0x8E8E8E,
            "transparent": false,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
  
            "map": {
              "texture": require('./../../assets/TUCSON/maps/YVA69T_d.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 1,"y": 1},
            },
            "normalMap": {
              "texture": require('./../../assets/TUCSON/maps/BPE6C3_n.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 0.5,"y": 0.5},
            },
            "normalScale": {"x": 0.5,"y": -0.5},
  
            "aoMapIntensity": 1,
            "emissive": 0x000000,
            "emissiveIntensity": 1,
            "envMapIntensity": 5.2,
            "lightMapIntensity": 0,
            "metalness": 0.75,
            "roughness": 0.425,
          },

        "Pillars":{
          "type": "standard",
          "enable": true,
          "color": 0xD8D8D8,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/TPDRN3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1.2,"y": -1.2},
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 0.9,
        },

        "Belts":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/Image_9_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Image_9_Invert_nrm.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Carpet":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/TFBCA9_d.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0.5,"y": 0.5},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.5,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,
        },


        "FabricSeatsT2":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/Image_26.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 6,"y": 6},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Image_27.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 6,"y": 6},
          },
          "normalScale": {"x": 0.5,"y": -0.5},
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 0.3,
          "roughness": 0.4,
        },

        "Leather_Smooth":{
          "type": "standard",
          "enable": true,
          "color": 0x414141,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/BPE6C3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0.8,"y": 0.8},
          },
          "normalScale": {"x": 1,"y": -1},
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 4.7,
          "lightMapIntensity": 0,
          "metalness": 0.6,
          "roughness": 0.4,
        },
          "Leather_Seats":{
            "type": "standard",
            "enable": true,
            "color": 0x333333,
            "transparent": false,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
  
            "normalMap": {
              "texture": require('./../../assets/STARIA/maps/BPE6C3_n.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 1.2,"y": 1.2},
            },
            "normalScale": {"x": 0.7,"y": -0.7},
            "envMap": { "texture": "globalEnvMap" },
  
            "aoMapIntensity": 1,
            "emissive": 0x000000,
            "emissiveIntensity": 1,
            "envMapIntensity": 6.7,
            "lightMapIntensity": 0,
            "metalness": 0.75,
            "roughness": 0.4,
          },

          "NettingSeat":{
            "type": "standard",
            "enable": true,
            "color": 0x000000,
            "transparent": true,
            "opacity": 1,
            "depthTest": true,
            "depthWrite": true,
            
            "alphaMap": {
              "texture": require('./../../assets/STARIA/maps/Image_16.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1007,
              "magFilter": 1007,
              "anisotropy": 1,
              "repeat": {"x": 36,"y": 36},
            },
            "envMap": { "texture": "globalEnvMap" },
  
            "aoMapIntensity": 1,
            "emissive": 0x000000,
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "lightMapIntensity": 0.5,
            "metalness": 1,
            "roughness": 0.35,
          },

        "Roofliner":{
          "type": "standard",
          "enable": true,
          "color": 0xD6D6D6,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/TPDRN3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 0.75,"y": -0.75},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 0.85,
        },

        "Screen1":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/STARIA/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.8,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Screen2":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/STARIA/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/STARIA/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.8,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },
        
        "StitchesSeats":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,
        
          "map": {
            "texture": require('./../../assets/STARIA/maps/Sewing01Alpha.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },

          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/Sewing01Alpha.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Sewing01_Nrm.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0.5,
          "metalness": 0,
          "roughness": 0.65,
        },

      "StWheelPlastic":{
        "type": "standard",
        "enable": true,
        "color": 0x353535,
        "transparent": false,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,

        "normalMap": {
          "texture": require('./../../assets/STARIA/maps/Image_24_Invert.jpg'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": true,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },
        "normalScale": {"x": 1,"y": -1},
        "envMap": { "texture": "globalEnvMap" },

        "aoMapIntensity": 1,
        "emissive": 0x000000,
        "emissiveIntensity": 1,
        "envMapIntensity": 8,
        "lightMapIntensity": 0,
        "metalness": 0.45,
        "roughness": 0.47,
      },

      "Stitching_Cross":{
        "type": "standard",
        "enable": true,
        "color": 0x747474,
        "transparent": true,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,

        "alphaMap": {
          "texture": require('./../../assets/STARIA/maps/SWStitches_d.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": true,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },

        "normalMap": {
          "texture": require('./../../assets/STARIA/maps/SWStitches_n.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": true,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },
        "normalScale": {"x": 1,"y": -1},
        "envMap": { "texture": "globalEnvMap" },

        "aoMapIntensity": 1,
        "emissive": 0x000000,
        "emissiveIntensity": 1,
        "envMapIntensity": 2,
        "lightMapIntensity": 1,
        "metalness": 0,
        "roughness": 0.65,
      },

      "TextButtonsBlueGlossy":{
        "type": "standard",
        "enable": true,
        "color": 0xFFFFFF,
        "transparent": false,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,

        "map": {
          "texture": require('./../../assets/STARIA/maps/Image_7_Invert.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": false,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },
        
        "emissiveMap": {
          "texture": require('./../../assets/STARIA/maps/Image_8_Invert.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": false,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },

        "aoMapIntensity": 1,
        "emissive": 0xFFFFFF,
        "emissiveIntensity": 1,
        "envMapIntensity": 3,
        "lightMapIntensity": 0,
        "metalness": 0.8,
        "roughness": 0,
      },

      "Placa":{
        "type": "standard",
        "enable": true,
        "color": 0xFFFFFF,
        "transparent": false,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,
        
        "map": {
          "texture": require('./../../assets/STARIA/maps/Placa.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": false,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 0,"y": 0},
        },

        "envMap": { "texture": "globalEnvMap" },

        "aoMapIntensity": 1,
        "emissive": 0x000000,
        "emissiveIntensity": 1,
        "envMapIntensity": 1,
        "lightMapIntensity": 1,
        "metalness": 0,
        "roughness": 0.5,
      },

      "TextButtonsWhite":{
        "type": "standard",
        "enable": true,
        "color": 0xA5A5A5,
        "transparent": false,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,

        "map": {
          "texture": require('./../../assets/STARIA/maps/Image_7_Invert.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": false,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },
        
        "aoMapIntensity": 1,
        "emissive": 0x000000,
        "emissiveIntensity": 1,
        "envMapIntensity": 1,
        "lightMapIntensity": 0,
        "metalness": 0.8,
        "roughness": 0,
      },

        "ShadowCaps":{
          "type": "standard",
          "enable": true,
          "color": 0x000000,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/AOTires_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },
        "Tire":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
            "texture": require('./../../assets/STARIA/maps/Image_35_Invert.png'),
            "channel": 1,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/Image_33_Invert.jpg'),
            "channel": 0,
            "flipY": true,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Image_34_Invert.jpg'),
            "channel": 0,
            "flipY": true,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "aoMap": { "texture": "sharedMap" },
          "lightMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.55,
          "lightMapIntensity": 2,
          "metalness": 0.85,
          "roughness": 0.40,
        },
        
        "Rin":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "sharedMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_ORM_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},

          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/Rin_Diffuse_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_Alpha_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_Normal_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.5,
          "lightMapIntensity": 0.1,
          "metalness": 1,
          "roughness": 1,
          "normalScale": {"x": 0.4,"y": -0.4},
          "realTimeEnvironment": true,
        },

        "Calippers":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "sharedMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_ORM_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},

          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/Disk.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/Disk_Alpha.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_Normal_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.8,
          "lightMapIntensity": 0.1,
          "metalness": 1,
          "roughness": 1,
          "normalScale": {"x": 0.4,"y": -0.4},
          "realTimeEnvironment": true,
        },

        "FrontGrill":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "sharedMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_ORM_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},

          },
          "map": {
            "texture": require('./../../assets/STARIA/maps/MeshFrontalV.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/MeshFrontalA.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/STARIA/maps/Rin_Normal_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.8,
          "lightMapIntensity": 0.1,
          "metalness": 1,
          "roughness": 1,
          "normalScale": {"x": 0.4,"y": -0.4},
          "realTimeEnvironment": true,
        },


        "RinShadow":{
          "type": "standard",
          "enable": true,
          "color": 0x000000,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/Rin_Alpha_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.5,
          "lightMapIntensity": 0.5,
          "metalness": 1,
          "roughness": 1,

          "realTimeEnvironment": true,
        },

        "M_Ground_Shadow":{
          "type": "basic",
          "enable": true,
          "color": 0x000000,
          "reflectivity": 1,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "alphaMap": {
              "texture": require('./../../assets/STARIA/maps/Shadow Cross Sport 2021_Invert.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "aoMapIntensity": 1,
          "lightMapIntensity": 1,
        },
        "M_LightBeams":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 0,
          "depthTest": true,
          "depthWrite": false,

          "sharedMap": {
            "texture": require('./../../assets/STARIA/maps/LightBeams.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1003,
            "magFilter": 1003,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/STARIA/maps/LightBeams_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1003,
            "magFilter": 1003,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "map": { "texture": "sharedMap" },
          "emissiveMap": { "texture": "sharedMap" },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 5,
          "envMapIntensity": 2,
          "lightMapIntensity": 0.0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "end", 
            "emissiveIntensity": 2,
            "envMapIntensity": 1,
            "opacity": 0.4,
          },
          "lightsOnTransition": {
            "updateAt": "start", 
            "emissiveIntensity": 5,
            "envMapIntensity": 2,
            "opacity": 0,
          },
        },

        "BASIC_DEFAULT":{
          "type": "basic",
          "enable": true,
          "color": 0xFFFFFF,
          "reflectivity": 1,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          //"sharedMap" | "alphaMap" | "aoMap" | "envMap" | "lightMap" | "map" | "specularMap"
          "sharedMap": {
              "texture": "", // require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0, "type": "Vector2"},
          },
          "aoMapIntensity": 1,
          "lightMapIntensity": 1,
        },
        "STANDARD_DEFAULT":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          //"sharedMap" | "alphaMap" | "aoMap" | "emissiveMap" | "envMap" | "lightMap" | "map" | "metalnessMap" | "normalMap" | "specularMap" | "roughnessMap"
          "sharedMap": {
              "texture": "", //require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0, "type": "Vector2"},
          },
          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,
          "normalScale": {"x": 1,"y": -1, "type": "Vector2"},

          //Updates
          "realTimeEnvironment": false,
          "lightsOnTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
          "lightsOffTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
        },
        "PHYSICAL_DEFAULT":{
          "type": "physical",
          "name": "",
          "enable": true,
          "color": 0xFFFFFF,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": false,
          "opacity": 1,
          "side": 0, //0:FrontSide | 1:BackSide | 2:DoubleSide
          "reflectivity": 0.5,
          "thickness": 0,
          "transmission": 0,

          //"sharedMap" | "alphaMap" | "aoMap" | "emissiveMap" | "envMap" | "lightMap" | "map" | "metalnessMap" | "normalMap" | "specularMap" | "roughnessMap"
          "sharedMap": {
              "texture": "", // "" | require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0, "type": "Vector2"},
          },
          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,
          "normalScale": {"x": 1,"y": -1, "type": "Vector2"},

          //Updates
          "realTimeEnvironment": false,
          "lightsOnTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
          "lightsOffTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
        },

      }
    }
  }
}